export const SEXOS = [
  { value: 'M', label: 'Masculino' },
  { value: 'F', label: 'Feminino' }
]

export function sexoLabel(value) {
  return SEXOS.find(s => s.value === value)?.label || null
}
